var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.142,
    height: 30.023,
    viewBox: "0 0 36.142 30.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download-cloud",
    "data-name": "Icon feather-download-cloud",
    transform: "translate(0.019 -2.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32985",
    "data-name": "Path 32985",
    d: "M12,25.5l6,6,6-6",
    fill: "none",
    stroke: "#24c444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32986",
    "data-name": "Path 32986",
    d: "M18,18V31.5",
    fill: "none",
    stroke: "#24c444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32987",
    "data-name": "Path 32987",
    d: "M31.32,27.135A7.5,7.5,0,0,0,27,13.5H25.11A12,12,0,1,0,4.5,24.435",
    fill: "none",
    stroke: "#24c444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptIcon);
export default __webpack_public_path__ + "static/media/receiptIcon.6f3392e791d65e0f97bbaa198e692a33.svg";
export { ForwardRef as ReactComponent };